import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import EditProfile from "./EditProfile";
import Booking from "./Booking";
import Hosting from "./Hosting";
import Accounts from "./Accounts";
import Page404 from "../Page404";
import { LoadingComp } from "../../components/LoadingComp";

import "./style.scss";

export default class Dashboard extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      user_id: "",
      isSocial: false,
      currency_id: 1
    };
  }

  renderPage(page) {
    let { user_id, currency_id, isSocial } = this.state;
    let { history } = this.props;
    switch (page) {
      case "edit-profile":
        return (
          <EditProfile
            isSocial={isSocial}
            user_id={user_id}
            history={history}
          />
        );
      case "booking":
        return <Booking user_id={user_id} history={history} />;
      case "hosting":
        return <Hosting user_id={user_id} />;
      case "accounts":
        return <Accounts user_id={user_id} currency_id={currency_id} />;
      default:
        return <Page404 />;
    }
  }

  componentDidMount() {
    let user = JSON.parse(localStorage.getItem("O_Auth"));
    this._isMounted = true;

    if (user && this._isMounted) {
      this.setState({
        user_id: user.id,
        isSocial: user.isSocial,
        currency_id: user.currency
      });
    } else {
      window.location.href = "/";
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let page = this.props.match.params.page;
    let { user_id } = this.state;

    return (
      <div className="dashboard">
        <nav className="nav-top" id="dash_footer_tab">
          <NavLink to="/dashboard/edit-profile">
            <span>
              <i className="fa fa-edit" />
              Edit Profile
            </span>
          </NavLink>
          <NavLink to="/dashboard/booking">
            <span>
              <i className="fa fa-calendar-check-o" />
              Booking
            </span>
          </NavLink>
          <NavLink to="/dashboard/hosting">
            <span>
              <i className="fa fa-server" /> Hosting
            </span>
          </NavLink>
          <NavLink to="/dashboard/accounts">
            <span>
              <i className="fa fa-money" />
              Accounts
            </span>
          </NavLink>
        </nav>
        {user_id !== "" ? (
          this.renderPage(page)
        ) : (
          <LoadingComp customStyle={{ padding: "200px 0" }} />
        )}
      </div>
    );
  }
}
